import {BsServer} from "@onemind-services-llc/react-icons-ng/bs";
import {
  FaServer,
  FaNetworkWired,
  FaMicrochip,
  FaMicrosoft,
} from "@onemind-services-llc/react-icons-ng/fa";
import MicrosoftWImage from "public/microsoft365/microsoft-logo-wbg.png";
import NvidiaWhite from "public/gpu-hosting/NVIDIA-logo-wbg.png";
import IntelLogo from "public/pricingPage/intel.png";
import AmdLogo from "public/pricingPage/amd.webp";
import {SiKubernetes} from "@onemind-services-llc/react-icons-ng/si";
import {RiFileCloudLine} from "@onemind-services-llc/react-icons-ng/ri";
import {MdCloudQueue} from "@onemind-services-llc/react-icons-ng/md";
import {AiOutlineCloudServer} from "@onemind-services-llc/react-icons-ng/ai";
import ColocationIcon from "public/pricingPage/colocation-icon.png";
import VmwareIcon from "public/pricingPage/vmware-icon.png";
import VmwareIconHover from "public/pricingPage/vmware-icon-hover-state.png";
import ColocationHover from "public/pricingPage/colocation-icon-hover-state.png";

export const SIDEBAR_CONSTANTS = [
  {
    icon: BsServer,
    label: "Baremetal",
    value: "baremetal",
  },
  {
    icon: AiOutlineCloudServer,
    label: "IaaS (Public Cloud)",
    options: [
      {
        label: "Intel Based Dedicated CPU ",
        value: "intel-based-dedicated-cpu",
        image: IntelLogo,
      },
      {
        label: "AMD Based Dedicated CPU",
        value: "amd-based-dedicated-cpu",
        image: AmdLogo,
      },
      {
        label: "Shared (Older Gen Intel CPU)",
        value: "older-generation-intel-cpu",
        image: IntelLogo,
      },
    ],
  },
  {
    icon: FaMicrochip,
    label: "Cloud GPU",
    options: [
      {
        label: "Enterprise GPU",
        value: "enterprise-gpu",
        image: NvidiaWhite,
        imageSize: 64,
      },
      {
        label: "Consumer GPU",
        value: "consumer-gpu",
        image: NvidiaWhite,
        imageSize: 64,
      },
    ],
  },
  {
    icon: FaMicrosoft,
    label: "Managed Microsoft 365",
    options: [
      {
        label: "Managed Security & Compliance",
        value: "microsoft-sec-bundles",
        image: MicrosoftWImage,
      },
      {
        label: "Managed Services Bundles",
        value: "microsoft-services-bundles",
        image: MicrosoftWImage,
      },
    ],
  },
  {
    icon: FaServer,
    label: "VDI",
    options: [
      {
        label: "Dedicated Server For Organization (For 10+ Users)",
        value: "dedicated-server-for-organization",
      },
      {
        label: "Dedicated VM Minimum 10 User (1:1 VM)",
        value: "dedicated-vm-minimum-10-user",
      },
      {
        label: "ISV Desktops",
        value: "isv-desktops",
      },
    ],
  },
  {
    icon: FaNetworkWired,
    label: "Public IPv4 / IPv6",
    value: "ipv4/v6",
  },
  {
    icon: SiKubernetes,
    label: "Kubernetes",
    value: "kubernetes",
  },
  {
    image: VmwareIcon,
    hoverImage: VmwareIconHover,
    label: "VMware",
    value: "vmware",
  },
  {
    icon: MdCloudQueue,
    label: "PaaS",
    value: "paas",
  },
  {
    image: ColocationIcon,
    hoverImage: ColocationHover,
    label: "Colocation",
    value: "colocation",
  },
  {
    icon: RiFileCloudLine,
    label: "Storage",
    options: [
      {
        label: "Performance Object Storage",
        value: "performance-object-storage",
      },
      {
        label: "NVME Block Storage",
        value: "block-storage",
      },
    ],
  },
];
